export const APIEventNameMap = {
  API_SERVER_ERROR: 'API_SERVER_ERROR',
  API_UN_LOGIN: 'API_UN_LOGIN',
};
